﻿export class Formulario {
    id: number;
    descricao: string;
    img: string;
    link: string;
}